<div id="disabledBuilder">
  <h1>{{ 'Trial Ended for this project' | translate }}</h1>
  <p>{{ 'Please switch or upgrade your project to renew your subscription' | translate }}</p>
  <div id="actionBtnsWrapper">
    <button [routerLink]="['/billing']" class="stacksBtn blue">{{ 'Subscribe Now' | translate }}</button>
    <a href="mailto:support@stacksmarket.co" class="stacksBtn green">{{ 'Contact Us' | translate }}</a>
  </div>
</div>
